// Central media registry for Sofas Contract
const S = "https://static.prod-images.emergentagent.com/jobs/a3fe29d5-5904-49c3-a8ec-e7f2762b1583/images";

export const BRAND = {
  logoFull: "/logo-sc.png",
  logoIcon: "/logo-emblem.png",
};

export const HERO = {
  home: "https://images.unsplash.com/photo-1758193783649-13371d7fb8dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBob3RlbCUyMGxvYmJ5JTIwZnVybml0dXJlfGVufDB8fHx8MTc4MzQ3NjI0OHww&ixlib=rb-4.1.0&q=85",
  aboutWorkshop: "/gallery/produzione/001.jpg",
};

// Sector categories
export const SECTORS = {
  realEstate: "https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjByZXNpZGVudGlhbCUyMGxpdmluZyUyMHJvb20lMjBsdXh1cnklMjBhcGFydG1lbnR8ZW58MHx8fHwxNzgzNDc2MzUzfDA&ixlib=rb-4.1.0&q=85",
  palazzi: "https://images.unsplash.com/photo-1664174728312-47aad71055c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3RlbCUyMGxvYmJ5JTIwbG91bmdlJTIwZnVybml0dXJlfGVufDB8fHx8MTc4MzQ3NjM1M3ww&ixlib=rb-4.1.0&q=85",
  uffici: "https://images.unsplash.com/photo-1774953037913-af0cf688491a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjBsb3VuZ2UlMjByZWNlcHRpb24lMjBmdXJuaXR1cmV8ZW58MHx8fHwxNzgzNDc2MzUzfDA&ixlib=rb-4.1.0&q=85",
  hotel: "https://images.unsplash.com/photo-1646991761123-d83ce47c30c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3RlbCUyMGxvYmJ5JTIwbG91bmdlJTIwZnVybml0dXJlfGVufDB8fHx8MTc4MzQ3NjM1M3ww&ixlib=rb-4.1.0&q=85",
  ristoranti: "https://images.unsplash.com/photo-1669310095420-8cd109dba5cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwcmVzdGF1cmFudCUyMGJhbnF1ZXR0ZSUyMHNlYXRpbmclMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODM1NTQ0Mjl8MA&ixlib=rb-4.1.0&q=85",
  outdoor: "https://images.unsplash.com/photo-1600210492090-a159ffa3aeaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBvdXRkb29yJTIwdGVycmFjZSUyMGZ1cm5pdHVyZXxlbnwwfHx8fDE3ODM0NzYzNTN8MA&ixlib=rb-4.1.0&q=85",
  zonePubbliche: "https://images.unsplash.com/photo-1535078035266-a0fa7d3b8f65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxhaXJwb3J0JTIwbG91bmdlJTIwcHVibGljJTIwc2VhdGluZyUyMGRlc2lnbnxlbnwwfHx8fDE3ODM0NzYzNTN8MA&ixlib=rb-4.1.0&q=85",
  tessuti: "https://images.unsplash.com/photo-1573227896778-8f378c4029d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxsZWF0aGVyJTIwZmFicmljJTIwc2FtcGxlcyUyMHRleHR1cmV8ZW58MHx8fHwxNzgzNDc2MzI0fDA&ixlib=rb-4.1.0&q=85",
};

// Real client photos (optimized) — see /app/frontend/src/data/galleryImages.js
export { PRODUCTION_GALLERY, PRODUCTS_GALLERY, DRAWINGS_GALLERY } from "./galleryImages";

export const PRODUCT_IMAGES = {
  divani: `${S}/de4bf85e4f8d3387ddf912a93480f2e2f8b5c3a6e51aa9e8544d137770b6724f.png`,
  modulari: `${S}/f756d6d560b89165cead56b3328bce198ad2b33639fbc2a93f29ea7b4ce406df.png`,
  poltrone: `${S}/dbbfb544653884ef66ca9491f434b48dd6d87c88af753709aca6f9e6842cf4c4.png`,
  divaniLetto: `${S}/72caf685926cdaccc5b5ecd3c466d2c575edf90ab083948406114e489a5b4d11.png`,
  letti: `${S}/218a927033c4454b11f1352f205be396cf42cb6c2a1039429bd5206256ac2353.png`,
  panche: `${S}/53d0943d047f99bcf74c8dfbc7848a65d5c46efbcc31ef935d8f23be68809a2a.png`,
  pouf: `${S}/cecb57c6129731e9061ae462cb3c2bad7e269f25dced016b76b24ec97d423a13.png`,
  barstools: `${S}/d801cc1dcd361bd0d7e92e3a27e6810046567a6b6cde1fa7417dfea8d59b7b9e.png`,
  chaise: `${S}/eceb207b1343750826c91e72443c5e96b1eb1169e07d426c211d42328c7a5314.png`,
  sedute: `${S}/3594e5e1d2559031649915bba6ff9a0878c5929c076a3a0ed9ab23f56ba4e86c.png`,
};

export const CONTACT = {
  address: "Via Monte Santo 20, 47121 Forlì (FC), Italia",
  emailInfo: "info@sofascontract.com",
  emailProject: "project@sofascontract.com",
  website: "www.sofascontract.com",
};

// Official catalog PDFs served as same-origin static files (frontend/public/catalogs).
// Independent from the backend API and any external service.
export const CATALOG_PDFS = {
  it: "/catalogs/catalog_it.pdf",
  en: "/catalogs/catalog_en.pdf",
  fr: "/catalogs/catalog_fr.pdf",
  es: "/catalogs/catalog_es.pdf",
};

export const BRANDS = [
  { name: "Marriott", logo: "/brands/marriott.png" },
  { name: "Hilton", logo: "/brands/hilton.png" },
  { name: "Four Seasons", logo: "/brands/four-seasons.png" },
  { name: "Caesars Palace", logo: "/brands/caesars.png" },
  { name: "Millennium Hotels", logo: "/brands/millennium.png" },
];
